// Utility functions for managing guest booking data in localStorage

export interface GuestBookingData {
  selectedDate?: string;
  selectedTime?: string;
  selectedService?: string;
  serviceId?: string;
  price?: number;
  appointmentData?: any;
  userInfo?: {
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    due_date?: string;
    child_name?: string;
    is_your_first_baby?: boolean;
    partner_support_person_name?: string;
    partner_support_person_email_address?: string;
  };
  timestamp?: number;
}

const GUEST_BOOKING_KEY = 'naps_guest_booking_data';

export const saveGuestBookingData = (data: Partial<GuestBookingData>): void => {
  try {
    const existingData = getGuestBookingData();
    const updatedData = {
      ...existingData,
      ...data,
      timestamp: Date.now()
    };
    localStorage.setItem(GUEST_BOOKING_KEY, JSON.stringify(updatedData));
  } catch (error) {
    console.error('Error saving guest booking data:', error);
  }
};

export const getGuestBookingData = (): GuestBookingData => {
  try {
    const data = localStorage.getItem(GUEST_BOOKING_KEY);
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error('Error retrieving guest booking data:', error);
    return {};
  }
};

export const clearGuestBookingData = (): void => {
  try {
    localStorage.removeItem(GUEST_BOOKING_KEY);
  } catch (error) {
    console.error('Error clearing guest booking data:', error);
  }
};

export const isGuestBookingDataValid = (maxAgeHours: number = 24): boolean => {
  const data = getGuestBookingData();
  if (!data.timestamp) return false;
  
  const now = Date.now();
  const maxAge = maxAgeHours * 60 * 60 * 1000; // Convert hours to milliseconds
  return (now - data.timestamp) < maxAge;
};

export const updateGuestUserInfo = (userInfo: Partial<GuestBookingData['userInfo']>): void => {
  const existingData = getGuestBookingData();
  saveGuestBookingData({
    ...existingData,
    userInfo: {
      ...existingData.userInfo,
      ...userInfo
    }
  });
};
